import React, { useState } from "react";
import MediaCards from "../../components/Card";
import RecentFiles from "../../components/RecentFiles";

import { Button } from "antd";
import UploadFile from "./UploadFile";

const Dashboard = () => {
  const [visible, setVisible] = useState(false);

  return (
    <div className="dashboard">
      {/* <div className="section-title">Cloud Storage</div> */}

      <MediaCards />
    </div>
  );
};

export default Dashboard;
